import { useTranslation } from "react-i18next";

import Tag, { TAG_COLORS, TAG_SIZES } from "components/DesignComponents/Tag";
import {
    BOOLEAN_FILTER,
    INVALID,
    LEGACY,
    NOT_ASSIGNED,
    UNKNOWN
} from "shared/constants/strings";
import { isTranslatableFilter } from "shared/functions";
import { FILTER_NAMES } from "shared/types/enums";
import { FilterId } from "shared/types/types";

import { SingleFilteredValueProps } from "./types/interfaces";

const SingleFilteredValue = ({
    filterName,
    value,
    handleDelete
}: SingleFilteredValueProps) => {
    const { t } = useTranslation();

    const getTitle = (
        id: FilterId,
        name: string,
        isTranslatable: boolean,
        filterName: FILTER_NAMES
    ) => {
        const isNotAssigned = name === NOT_ASSIGNED;
        const isInvalid = name === INVALID;
        const isUnknown = name === UNKNOWN;
        const isLegacy = name === LEGACY;
        const isBooleanFilter = name === BOOLEAN_FILTER;

        if (isNotAssigned) {
            return t(`General##not assigned ${filterName}`);
        }

        if (isInvalid) {
            return t(`General##invalid ${filterName}`);
        }

        if (isUnknown) {
            return t(`General##unknown ${filterName}`);
        }

        if (isLegacy) {
            return t(`General##legacy ${filterName}`);
        }

        if (isBooleanFilter) {
            return t(
                `General##boolean filtered value name##${filterName}##${id}`
            );
        }

        if (isTranslatable) {
            return t(`General##${name}`);
        }

        return name;
    };

    const isTranslatable = isTranslatableFilter(filterName);

    return value.map(({ id, name }) => {
        const title = getTitle(id, name, isTranslatable, filterName);

        return (
            <Tag
                key={`${id}_${name}`}
                size={TAG_SIZES.Medium}
                color={TAG_COLORS.Primary}
                title={title}
                onDelete={() => handleDelete(filterName, id)}
            />
        );
    });
};

export default SingleFilteredValue;
